import { Canvas, FilterSettings, Participant, StatusName, TagName } from '@range.io/basic-types'
import { tagged } from '@range.io/functional'
import PropTypes from 'prop-types'
import React from 'react'
import FilterSelector from './filters/FilterSelector.js'

/*
 * FilterForTaskList select from about a dozen different filters
 * @sig FilterForTaskList = ({ LookupTable, LookupTable, FilterSettings, F) -> React component
 *  F = FilterSettings -> ()
 */
const FilterForTaskList = ({
    allCanvases,
    allCategories,
    allIdentifiers,
    allParticipants,
    allStatuses,
    allTags,
    isDataLoaded,
    projectIdentifier,
    filterSettings,
    setFilterSettings,
}) => {
    const groupStyles = {
        status: { ml: 0, mr: 0, p: '16px', w: '100%' },
        assignee: { p: '16px', w: '100%' },
        category: { p: '16px', w: '100%' },
        follower: { p: '16px', w: '100%' },
        canvas: { p: '16px', w: '100%' },
    }

    return (
        <FilterSelector
            alignment="end"
            allCanvases={allCanvases}
            allCategories={allCategories}
            allIdentifiers={allIdentifiers}
            allParticipants={allParticipants}
            allStatuses={allStatuses}
            allTags={allTags}
            dataCy="task-list-filter-button"
            filterSettings={filterSettings}
            filterTitle="Task List Filters"
            groupStyles={groupStyles}
            isDataLoaded={isDataLoaded}
            projectIdentifier={projectIdentifier}
            setFilterSettings={setFilterSettings}
            showCanvasGroup={true}
            showFilterText={true}
            showPhotosGroup={false}
            tooltipText="Task List Filters"
            variant="taskListFilterButton"
        />
    )
}

FilterForTaskList.propTypes = {
    allCanvases: PropTypes.arrayOf(tagged.typeIsRequired(Canvas)).isRequired,
    allParticipants: PropTypes.arrayOf(tagged.typeIsRequired(Participant)).isRequired,
    allStatuses: PropTypes.arrayOf(tagged.typeIsRequired(StatusName)).isRequired,
    allTags: PropTypes.arrayOf(tagged.typeIsRequired(TagName)).isRequired,
    filterSettings: tagged.typeIsRequired(FilterSettings),
    setFilterSettings: PropTypes.func.isRequired,
}

export default FilterForTaskList
